import * as actionTypes from './hostReportActionTypes';

const initialState = {
    // Bookings Table - full data from API (client-side filtering in component)
    dataSource: [],
    loading: false,
    error: null,
    
    // Blocked By Host Table
    blockedDataSource: [],
    blockedLoading: false,
    blockedError: null,
    
    // Google Calendar Table
    googleDataSource: [],
    googleLoading: false,
    googleError: null,

    liveCounts: {
        ongoing: 0,
        upcoming: 0,
        tentative: 0
    },
    liveCountsLoading: false,
    stats: {
        totalBookings: 0,
        confirmedBookings: 0,
        pastBookings: 0,
        cancelledBookings: 0,
        tentativeBookings: 0
    },
    statsLoading: false,
    spaceList: [],
    spaceListLoading: false,
    activeTab: 'bookings',
    exportLoading: false,
};

export const hostReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LIVE_COUNTS:
            return {
                ...state,
                liveCountsLoading: true
            };
        case actionTypes.FETCH_LIVE_COUNTS_SUCCESS:
            return {
                ...state,
                liveCountsLoading: false,
                liveCounts: action.payload
            };
        case actionTypes.FETCH_LIVE_COUNTS_FAILURE:
            return {
                ...state,
                liveCountsLoading: false
            };

        case actionTypes.FETCH_HOST_REPORT_STATS:
            return { ...state, statsLoading: true };
            
        case actionTypes.FETCH_HOST_REPORT_STATS_SUCCESS:
            return { 
                ...state, 
                statsLoading: false, 
                stats: action.payload 
            };
            
        case actionTypes.FETCH_HOST_REPORT_STATS_FAILURE:
            return { ...state, statsLoading: false, error: action.payload };

        case actionTypes.FETCH_HOST_SPACES:
            return {
                ...state,
                spaceListLoading: true
            };
        case actionTypes.FETCH_HOST_SPACES_SUCCESS:
            return {
                ...state,
                spaceListLoading: false,
                spaceList: action.payload
            };
        case actionTypes.FETCH_HOST_SPACES_FAILURE:
            return {
                ...state,
                spaceListLoading: false,
                // Optional: handle error
            };
        case actionTypes.FETCH_HOST_REPORT_DATA:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.FETCH_HOST_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                dataSource: action.payload.dataSource,
            };
        case actionTypes.FETCH_HOST_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                dataSource: [],
                error: action.payload
            };

        // Blocked By Host
        case actionTypes.FETCH_BLOCKED_REPORT_DATA:
            return {
                ...state,
                blockedLoading: true,
            };
        case actionTypes.FETCH_BLOCKED_REPORT_SUCCESS:
             return {
                ...state,
                blockedLoading: false,
                blockedDataSource: action.payload.dataSource,
            };
        case actionTypes.FETCH_BLOCKED_REPORT_FAILURE:
             return {
                ...state,
                blockedLoading: false,
                blockedDataSource: [],
                blockedError: action.payload
            };
            
        // Google Report Actions
        case actionTypes.FETCH_GOOGLE_REPORT_DATA:
            return {
                ...state,
                googleLoading: true,
            };
        case actionTypes.FETCH_GOOGLE_REPORT_SUCCESS:
             return {
                ...state,
                googleLoading: false,
                googleDataSource: action.payload.dataSource,
            };
        case actionTypes.FETCH_GOOGLE_REPORT_FAILURE:
             return {
                ...state,
                googleLoading: false,
                googleDataSource: [],
                googleError: action.payload
            };

        case actionTypes.SET_HOST_REPORT_TAB:
            return {
                ...state,
                activeTab: action.payload,
            };
        case actionTypes.RESET_HOST_REPORT_STATE:
            return initialState;
        case actionTypes.EXPORT_REPORT_REQUEST:
            return {
                ...state,
                exportLoading: true
            };
        case actionTypes.EXPORT_REPORT_SUCCESS:
        case actionTypes.EXPORT_REPORT_FAILURE:
            return {
                ...state,
                exportLoading: false
            };
        default:
            return state;
    }
};
